<template>
  <div class="container">
    <div class="need-page trans">
      <need-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <div class="text">
         <RichHtml :content="treatiseReqText"></RichHtml>
        </div>
        <!-- <el-button>下载投稿须知</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
  import needHeader from "@/components/header"
  import { TreatiseReq } from "@/store/entity/treatisereq"
  import CurrentConferenceMixin from "@/mixin/CurrentConference"
  import RichHtml from "@/components/RichHtml"
  export default {
    name: "NeedPage",
    mixins: [CurrentConferenceMixin],
    components: {
      needHeader,
      RichHtml
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "投稿须知",
        },
        treatiseReqText: "",
      }
    },
    watch: {
      "currentConference.id": function (id, oldId) {
        if (id && id > 0) {
          this.getReqText()
        }
      },
    },
    created() {
      if (this.currentConference.id > 0) {
        this.getReqText()
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
      async getReqText(conference_id) {
        const treatisereq = await TreatiseReq.getList(conference_id)
        this.treatiseReqText = treatisereq.require
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .text {
      margin-top: 15px;
      padding: 15px;
      min-height: 240px;
      border-radius: 5px;
      box-sizing: border-box;
      line-height: 25px;
      color: #424242;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
      font-size: 16px;
    }

    .el-button {
      width: 100%;
      margin: 30px 0;
      color: #fff;
      background: var(--main-color);
    }
  }
</style>
